import { Request } from "express";
import { BobRequest } from "../model/bob-request";
import { IPipeline } from "./pipeline.inferface";
import { TracingComponent } from "./tracing-component";

export class BobRequestPipeline implements IPipeline<Request, Promise<BobRequest>> {

	constructor(
		private bobRequestTranslatorComponent: TracingComponent<Request, BobRequest>,
		private microserviceIdentifierComponent: TracingComponent<BobRequest, BobRequest>,
		private microserviceLoaderComponent: TracingComponent<BobRequest, BobRequest>,
		private bobRequestSerializingComponent: TracingComponent<BobRequest, BobRequest>
	) {}

	public async run(input: Request): Promise<BobRequest> {

		this.bobRequestTranslatorComponent.connectTo(this.microserviceIdentifierComponent);
		this.microserviceIdentifierComponent.connectTo(this.microserviceLoaderComponent);
		this.microserviceLoaderComponent.connectTo(this.bobRequestSerializingComponent);

		return await this.bobRequestTranslatorComponent.process(input);
	}
}
